import React, { useState, useEffect } from "react";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const AddUserForm = ({ fetchUsers, userToEdit, closeForm }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    if (userToEdit) {
      setFormData({
        name: userToEdit.name || "",
        mobile: userToEdit.mobile || "",
        email: userToEdit.email || "",
      });
    }
  }, [userToEdit]);

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (userToEdit) {
        await apiService.postData("admin/update-user", {
          ...formData,
          user_id: userToEdit.user_id,
        });
        toast.success("User updated successfully!");
      } else {
        await apiService.postData("admin/add-new-user", formData);
        toast.success("User added successfully!");
      }
      fetchUsers();
      closeForm();
    } catch (error) {
      toast.error("Error submitting form. Please try again.");
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div className="row">
        <div className="col-12 col-md-12">
          <div className="card">
            <div className="card-header">
              <h4>{userToEdit ? "Edit User" : "Add New User"}</h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleFormChange}
                    placeholder="Enter Name"
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-phone"></i>
                      </div>
                    </div>
                    <input
                      type="text"
                      name="mobile"
                      className="form-control phone-number"
                      value={formData.mobile}
                      onChange={handleFormChange}
                      placeholder="Enter Phone Number"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleFormChange}
                    placeholder="Enter Email"
                  />
                </div>
                <div className="d-flex gap-2 mt-3">
                  <button type="submit" className="btn btn-primary">
                    {userToEdit ? "Update User" : "Add User"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeForm}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUserForm;
